import { Suspense } from 'react';
import SimpleLoader from './loader';

export const Loadable =
  (Component: React.LazyExoticComponent<React.ComponentType>) => (props: JSX.IntrinsicAttributes) => (
    <Suspense
      fallback={
        <div className="flex justify-center items-center">
          <SimpleLoader />
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  );
